import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=706cb0f0&scoped=true"
import script from "./hint.vue?vue&type=script&lang=js"
export * from "./hint.vue?vue&type=script&lang=js"
import style0 from "./hint.vue?vue&type=style&index=0&id=706cb0f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706cb0f0",
  null
  
)

export default component.exports